import { Menu, WebContents, BrowserWindow } from "electron";

const inputMenu = Menu.buildFromTemplate([
	{ role: "undo" },
	{ role: "redo" },
	{ type: "separator" },
	{ role: "cut" },
	{ role: "copy" },
	{ role: "paste" },
	{ type: "separator" },
	{ role: "selectAll" },
]);

const selectionMenu = Menu.buildFromTemplate([{ role: "copy" }, { type: "separator" }, { role: "selectAll" }]);

/**
 * Handles a context-menu (right click). This is called whenever a component's `contextMenu` flag
 * is set to true in its `window` config (default is true).
 *
 * This has limited support compared to Chrome. If there is editable text then a menu with input
 * capabilities is created to handle it. If there is selected text then a menu with text selection
 * capabilities is created to handle it.
 */
export const enableContextMenu = (webContents: WebContents, bw: BrowserWindow) => {
	webContents.on("context-menu", (e, props) => {
		const { selectionText, isEditable } = props;
		if (isEditable) {
			inputMenu.popup({ window: bw });
		} else if (selectionText && selectionText.trim() !== "") {
			selectionMenu.popup({ window: bw });
		}
	});
};
